import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/site";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/admin", { replace: true }); return; }
      const sessionId = decodeURIComponent(m[1]);
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        navigate("/admin/login?error=1", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#F7F5F0]">
      <div className="flex items-center gap-3 text-[#1B3626]"><Loader2 className="animate-spin" size={20}/> Logger inn…</div>
    </div>
  );
}
